import styled from 'styled-components';
import { getThemeColor } from 'utils/styled';
import { CARD_BORDER_RADIUS_PX } from './constants';
import { CardStyleProps } from './types';

export const Root = styled.div<CardStyleProps>`
  background-color: ${getThemeColor('l2')};
  border-radius: ${({ fullScreen }) =>
    fullScreen ? 0 : `${CARD_BORDER_RADIUS_PX}px`};
  box-shadow: ${({ fullScreen }) =>
    fullScreen ? 'none' : '0 2px 30px 2px rgba(0, 0, 0, 0.15)'};
  color: ${getThemeColor('d1')};
  text-align: center;

  ${({ fullScreen }) =>
    !fullScreen
      ? undefined
      : `
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    overflow: auto; 
  `};
`;
